<template>
  <memlist-card>

    <div v-if="!local_sendout">
      <div class="d-flex justify-content-center mb-8 mt-8">
        <memlist-spinner />
      </div>
    </div>
    <div v-else>
      <m-row>
        <m-col lg="6">
          <div class="w-48">
            <h3 class="font-semibold truncate">{{ running_or_not_text }}: {{ local_sendout.name }}</h3>
            <p class="text-sm text-gray-500"><b>Start:</b> {{ formattedDate }}</p>
          </div>
          

          <m-row>
            <m-col lg="12">
              <memlist-progress-bar :title="$t('SENDOUT.JOB_PROGRESS')" :max_value="local_sendout.num_to_send" :current_value="local_sendout.num_processed" />
            </m-col>

          </m-row>

          <m-row>
            <m-col lg="12">
              <memlist-button
                v-if="is_running"
                class="mt-4"
                ref="stop-sendout-button"
                variant="danger"
                @click="stop_sendout"

              >{{ $t('SENDOUT.STOP_JOB') }}</memlist-button>
            </m-col>
          </m-row>
        </m-col>
        <m-col lg="6">

          <div class="d-flex justify-end">
            <memlist-spinner-icon-button
              
              ref="export-xlsx-button"
              class="mt-4 mb-4"
              icon="menu-icon flaticon2-file"
              :text="$t('SENDOUT.EXPORT_REPORT')"
              variant="primary"
              @click="export_xlsx_clicked"

            />
          </div>

          <memlist-thin-progress-bar title="Antal levererade" :max_value="local_sendout.num_to_send" :current_value="local_sendout.num_delivered" />
          <memlist-thin-progress-bar title="Antal första öppningar" :max_value="local_sendout.num_to_send" :current_value="local_sendout.num_opens" />
          <memlist-thin-progress-bar title="Antal första klick" :max_value="local_sendout.num_to_send" :current_value="local_sendout.num_clicks" />
        </m-col>
      </m-row>

      <!-- todo: Hide the button to show details for now -->
      <m-row class="mt-8" v-if="false">
        <m-col lg="12">
          <div class="d-flex justify-end">
            <memlist-button @click="show_details_clicked" variant="outline-primary">{{ show_details_text }}</memlist-button>
          </div>
        </m-col>
      </m-row>

      <m-row class="mt-8">
        <m-col lg="12">

          <div class="ml-tabs">
            <div class="ml-tabs-header">
              <button
                type="button"
                v-for="(tab, i) in tabs"
                :key="i"
                :class="['ml-tab-button', active_tab === i ? 'active' : '']"
                @click="active_tab = i"
                :disabled="tab.disabled"
              >
                {{ $t(tab.label, { count_type: count_types[i] }) }}
              </button>
            </div>

            <div class="ml-tabs-body">
              <div v-show="active_tab === 0">
                <SendoutEmailCallbackTable :sendout_id="local_sendout.sendout_id" type="Delivery" />
              </div>
              <div v-show="active_tab === 1">
                <SendoutEmailCallbackTable :sendout_id="local_sendout.sendout_id" type="Open" />
              </div>
              <div v-show="active_tab === 2">
                <SendoutEmailCallbackTable :sendout_id="local_sendout.sendout_id" type="Click" />
              </div>
              <div v-show="active_tab === 3">
                <SendoutEmailCallbackTable :sendout_id="local_sendout.sendout_id" type="SpamComplaint" />
              </div>
              <div v-show="active_tab === 4">
                <SendoutEmailCallbackTable :sendout_id="local_sendout.sendout_id" type="Bounce" />
              </div>
            </div>
          </div>
        </m-col>
      </m-row>

      <div v-if="showing_details">
        <m-row class="mt-4">
          <m-col lg="12"><p>Obs! Datat är påhittat</p></m-col>
        </m-row>
        <m-row class="mt-4">
          <m-col lg="12">
            <MemlistBarChart />
          </m-col>
        </m-row>

        <m-row class="mt-8">
          <m-col lg="6">
            <span style="font-weight: 500;">Leverans</span>
            <hr/>
            <MemlistDoughnutChart />
          </m-col>
          <m-col lg="6">
            <span style="font-weight: 500;">Heatmap/Clicks</span>
            <hr/>
            <div class="mt-4 w-40 h-24" style="max-width: 200px;" v-if="heatmapSrc">
              <img :src="heatmapSrc" alt="Heatmap" style="max-width: 200px;" class="w-full h-full object-contain rounded shadow" />
            </div>
          </m-col>
        </m-row>
      </div>

    </div>

    
  </memlist-card>
</template>

<script>
import axios from 'axios';
import MemlistDoughnutChart from './MemlistDoughnutChart.vue';
import MemlistLineChart from './MemlistLineChart.vue';
import MemlistBarChart from './MemlistBarChart.vue';
import SendoutEmailCallbackTable from './SendoutEmailCallbackTable.vue';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';

export default {
  name: 'SendoutInProgressComponent',
  components: {
    MemlistLineChart,
    MemlistDoughnutChart,
    MemlistBarChart,
    SendoutEmailCallbackTable,
  },
  props: {
    /**
     * Expected shape of `sendout`:
     * {
     *   name: String,
     *   startedAt: String | Number | Date,
     *   processed: Number,
     *   totalRecipients: Number,
     *   opensPerDay: [ { date: '2025‑07‑10', count: 123 }, … ],
     *   stats: {
     *     success: Number,
     *     softBounce: Number,
     *     hardBounce: Number,
     *     invalid: Number
     *   }
     * }
     */
    sendout: { type: Object, required: true }
  },
  data() {
    return {
      lookup_stats: {
        Open: 1,
        Delivery: 0,
        SpamComplaint: 3,
        Bounce: 4,
        SubscriptionChange: -1,
        Click: 2,
      },

      active_tab: null,
      count_types: [
        0, 0, 0, 0, 0
      ],
      showing_details: false,

      local_sendout: null,
      interval_id: null,
    }
  },
  computed: {
    tabs() {
      let base = [
        { label: 'SENDOUT.CALLBACK_TYPES.DELIVERY', disabled: false },
        { label: 'SENDOUT.CALLBACK_TYPES.OPEN', disabled: false },
        { label: 'SENDOUT.CALLBACK_TYPES.CLICK', disabled: false },
        { label: 'SENDOUT.CALLBACK_TYPES.SPAM', disabled: false },
        { label: 'SENDOUT.CALLBACK_TYPES.BOUNCE', disabled: false },
      ];

      return base;
    },

    is_running() {
      if (this.sendout.status === 'STARTUP' || this.sendout.status === 'RUNNING') {
        return true;
      }

      return false;
    },

    running_or_not_text() {
      if (this.sendout.status === 'SCHEDULED') {
        return this.$t('SENDOUT.SCHEDULED');
      }

      if (this.sendout.status === 'STARTUP') {
        return this.$t('SENDOUT.STARTUP');
      }

      if (this.sendout.status === 'RUNNING') {
        return this.$t('SENDOUT.RUNNING');
      }

      if (this.sendout.status === 'FINISHED' || this.sendout.status === 'CANCELLED' || this.sendout.status === 'FAILED') {
        return this.$t('SENDOUT.FINISHED');
      }

      return this.$t('SENDOUT.UNKNOWN');
    },
    show_details_text() {
      return this.showing_details ? this.$t('SENDOUT.HIDE_DETAILS') : this.$t('SENDOUT.SHOW_DETAILS');
    },
    heatmapSrc () {

      const { protocol, hostname } = window.location;

      // If you’re developing locally, always hit the API on port 3020.
      // Otherwise use the current host (no explicit port → 80 or 443).
      const base =
        hostname === 'localhost' || hostname === '127.0.0.1'
          ? `${protocol}//${hostname}:3020`
          : `${protocol}//${hostname}`;

      return `${base}/template-preview/${this.sendout.template_id}`;
    
    },

    // ---- Progress helpers ----
    progressPercent () {
      const { processed = 0, totalRecipients = 0 } = this.sendout
      return totalRecipients ? ((processed / totalRecipients) * 100).toFixed(1) : 0
    },
    progressLabel () {
      const { processed = 0, totalRecipients = 0 } = this.sendout
      return `${processed.toLocaleString()} / ${totalRecipients.toLocaleString()}`
    },
    formattedDate () {

      if (this.local_sendout.finished_at) {
        return new Date(this.local_sendout.finished_at).toLocaleDateString(undefined, {
          year: 'numeric', month: 'short', day: 'numeric'
        })
      }

      if (!this.local_sendout.started_at && !this.local_sendout.scheduled_at) {
        return '...';
      }

      return new Date(this.local_sendout.started_at || this.local_sendout.scheduled_at).toLocaleDateString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric'
      })
    },

    // ---- Line chart (opens) ----
    lineChartData () {
      const labels = this.sendout.opensPerDay.map(d => d.date)
      const data = this.sendout.opensPerDay.map(d => d.count)
      return {
        labels,
        datasets: [{
          label: 'Opens',
          data,
          fill: false,
          tension: 0.3,
          borderWidth: 2
        }]
      }
    },
    lineChartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { intersect: false }
        },
        scales: {
          x: {
            ticks: { maxTicksLimit: 4 },
            grid: { display: false }
          },
          y: {
            beginAtZero: true,
            grid: { display: false }
          }
        }
      }
    },

    // ---- Doughnut chart (delivery stats) ----
    doughnutChartData () {
      const s = this.sendout.stats || {}
      return {
        labels: ['Delivered', 'Soft Bounce', 'Hard Bounce', 'Invalid'],
        datasets: [{
          data: [s.success || 0, s.softBounce || 0, s.hardBounce || 0, s.invalid || 0],
          backgroundColor: ['#10B981', '#FBBF24', '#EF4444', '#9CA3AF'],
          borderWidth: 0
        }]
      }
    },
    doughnutChartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '60%',
        plugins: {
          legend: {
            position: 'bottom',
            labels: { boxWidth: 12 }
          },
          tooltip: { callbacks: { label: ctx => `${ctx.label}: ${ctx.parsed.toLocaleString()}` } }
        }
      }
    }
  },
  watch: {

    sendout: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.start_polling();
      },
      immediate: true
    },
  },
  beforeDestroy() {
    clearInterval(this.interval_id);
  },
  methods: {
    start_polling() {
      if (this.interval_id) {
        clearInterval(this.interval_id);
      }

      this.poll_sendout();
      this.interval_id = setInterval(() => {
        this.poll_sendout();
      }, this.sendout.status === 'FINISHED' ? 5000 : 1000);
    },

    async stop_sendout() {
      clearInterval(this.interval_id);

      const res = await axios.post(`/sendout/cancel/${this.sendout.sendout_id}`, {});

      if (res.status === 204) {
        this.local_sendout.status = 'CANCELLED';
      }
    },
    async poll_sendout() {
      const res = await axios.get(`/sendout/poll/${this.sendout.sendout_id}`);

      if (res.status === 200) {
        this.local_sendout = res.data;

        this.count_types = [0,0,0,0,0];

        for (const stat of this.local_sendout.callback_stats) {
          if (!(stat.type in this.lookup_stats)) {
            continue;
          }

          this.count_types[this.lookup_stats[stat.type]] = stat.count_type;
        }

        this.count_types = [...this.count_types];
      }
    },
    async export_xlsx_clicked() {
      try {
        const res = await axios.post(`/sendout/report/delivery/${this.sendout.sendout_id}`, {});

        if (res.status === 201) {
          downloadWithAxios(get_base_url() + `/dlfile/${res.data.linkstr}`, res.data.name);
        }
      }
      catch (err) {
        console.error('export_xslx_clicked', err);
        
      }

      this.$refs['export-xlsx-button'].stop();
      
    },
    show_details_clicked() {
      this.showing_details = !this.showing_details;
    },
  }
}
</script>

<style scoped>
.sendout-row canvas {
  /* Preserve small chart height without letting Chart.js stretch */
  max-height: 96px;
}
</style>
